import PaymentCardForm from 'shared-assets/components/PaymentCardForm';

angular
  .module('kareo.ui.shared.directives.payment-card-form', [
    'react'
  ])
  .directive('paymentCardForm', dcPaymentCardForm);

dcPaymentCardForm.$inject = ['reactDirective'];

function dcPaymentCardForm(reactDirective) {
  const bindings = {
    stripeApiKey: '=',
    showSubmit: '=',
    formId: '=',
  };

  return reactDirective(PaymentCardForm, bindings, props => {
    return props;
  });
}
